import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'post'

export default class OspreyOffersClone extends BaseAction {
    constructor(dataKey, onError) {
        const id = '33392ed8-6046-11e9-8e2d-2f3fd94c8e5d'
        const path = `/${resource}/clone`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    clone(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-clone.js